import { TYPE } from '@/theme';
import React from 'react';
import { isMobile } from 'react-device-detect';
import styled from 'styled-components';
// User will replace this icon

const ButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    border: 1px solid #3563f3;
    background-color: white;
    border-radius: 20px;
    padding: 4px 16px 4px 4px;
    cursor: pointer;
    transition: all 0.2s ease;
    height: 40px;
    margin-right: 20px;

    ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-right: 0px;
    height: 40px;
    padding: 3px;
    margin-left: 8px;
    `};

    &:hover {
        opacity: 0.8;
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(53, 99, 243, 0.15);
    }
`;

const IconWrapper = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: #3563f3;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 24px;
    height: 24px;
    margin-right: 6px;
    `};
`;

interface Props {
    onClick?: () => void;
}

const DailyBoxDropButton: React.FC<Props> = ({ onClick }) => {
    return (
        <ButtonWrapper onClick={onClick}>
            <IconWrapper>
                {/* Replace src with your icon */}
                <img
                    src={require('@/assets/images/boxdrop.svg')}
                    alt="Daily Drop"
                />
            </IconWrapper>
            <TYPE.main fontSize={14} color="#1E1E1E" mobileFz={12}>
                {isMobile ? 'Daily Drop' : 'Lazbubu Daily Box Drop'}
            </TYPE.main>
        </ButtonWrapper>
    );
};

export default DailyBoxDropButton;
